﻿import ApplicationsChangeLog from './ApplicationsChangeLog';
import ApplicationsPreFilledData from './ApplicationsPreFilledData';
import ApplicationsQuoteAppData from './ApplicationsQuoteAppData';
import ApplicationsSessionLog from './ApplicationsSessionLog';
import { MASTER_DATE_FORMAT } from '@core/_globals/types/date-settings';
import ENUMS from '@core/classes/Enums';

import { formatDateToString } from '@core/services/util.date';
import util from '@core/services/util';

export default class Application {
	constructor(init) {
		if (init) {
			this.id = init.id;
			this.emailCode = init.emailCode;
			this.emailCodeExpiration = init.emailCodeExpiration ?? null;
			// ? formatDateToString(init.emailCodeExpiration, { formatString: DATE_FORMAT_WITH_LONG_TIME })
			// : init.emailCodeExpiration;
			this.phoneCode = init.phoneCode;
			this.phoneCodeExpiration = init.phoneCodeExpiration ?? null;
			// ? formatDateToString(init.phoneCodeExpiration, { formatString: DATE_FORMAT_WITH_LONG_TIME })
			// : init.phoneCodeExpiration;
			this.editLinkExpiration = init.editLinkExpiration ?? null;
			// ? formatDateToString(init.editLinkExpiration, { formatString: DATE_FORMAT_WITH_LONG_TIME })
			// : init.editLinkExpiration;
			this.isSingleQuestionEdit = init.isSingleQuestionEdit; //Only use this as a flag when calling the function that creates the CustomerPanelObject
			this.customerId = init.customerId;
			this.leadId = init.leadId;
			this.plaidId = init.plaidId;
			this.guarantorApplicationId = init.guarantorApplicationId;
			this.businessApplicationId = init.businessApplicationId;
			this.status = init.status;
			this.dateCreated = init.dateCreated ?? null;
			this.dateCompleted = init.dateCompleted ?? null;
			this.storeCode = init.storeCode;
			this.preFilledData = new ApplicationsPreFilledData(init.preFilledData);
			this.quoteAppData = new ApplicationsQuoteAppData({
				quoteAppData: init.quoteAppData,
				customerApp: this,
			});
			this.changeLogs = [];
			this.fiManagerGenerated = init.fiManagerGenerated;
			this.canSave = init.canSave;
			this.isEmailVerified = init.isEmailVerified;
			this.isPhoneVerified = init.isPhoneVerified;
			this.isLatestApplication = init.isLatestApplication;
			this.createAppParams = init.createAppParams;
			if (init.changeLogs) {
				init.changeLogs.forEach(cl => {
					this.changeLogs.push(new ApplicationsChangeLog(cl));
				});
			}
			this.sessionLogs = [];
			if (init.sessionLogs) {
				init.sessionLogs.forEach(sl => {
					this.sessionLogs.push(new ApplicationsSessionLog(sl));
				});
			}
		} else {
			this.id = null;
			this.emailCode = null;
			this.emailCodeExpiration = null;
			this.phoneCode = null;
			this.phoneCodeExpiration = null;
			this.editLinkExpiration = null;
			this.isSingleQuestionEdit = null;
			this.customerId = null;
			this.leadId = null;
			this.plaidId = null;
			this.guarantorApplicationId = null;
			this.businessApplicationId = null;
			this.status = 0;
			this.dateCreated = null;
			this.dateCompleted = null;
			this.storeCode = null;
			this.preFilledData = new ApplicationsPreFilledData();
			this.quoteAppData = new ApplicationsQuoteAppData({
				quoteAppData: null,
				customerApp: this,
			});
			this.isEmailVerified = false;
			this.isPhoneVerified = false;
			this.changeLogs = [];
			this.sessionLogs = [];
			this.canSave = null;
			this.isLatestApplication = null;
			this.createAppParams = {};
		}
	}

	getSanitizedData() {
		let sanitizedData = new Application(this);
		sanitizedData.quoteAppData = sanitizedData.quoteAppData.getSanitizedData();

		return sanitizedData;
	}

	isCompleted() {
		return this.dateCompleted != null;
	}

	setSNNType(ssn) {
		let ssnGroupNumber = ssn.slice(3, 5);
		if (
			ssn.slice(0, 1) == 9 &&
			((ssnGroupNumber >= 50 && ssnGroupNumber <= 65) ||
				(ssnGroupNumber >= 70 && ssnGroupNumber <= 88) ||
				(ssnGroupNumber >= 90 && ssnGroupNumber <= 92) ||
				(ssnGroupNumber >= 94 && ssnGroupNumber <= 99))
		) {
			this.quoteAppData.applicationsDataAnswered.personalInfo.ssnType = ENUMS.SSN_TYPES.ITIN;
		} else {
			this.quoteAppData.applicationsDataAnswered.personalInfo.ssnType = ENUMS.SSN_TYPES.SSN;
		}
	}

	isBusinessWithApplicantAsGuarantor() {
		if (
			this.quoteAppData.applicationsDataAnswered.isBusiness &&
			this.quoteAppData.applicationsDataAnswered.businessInfo.hasGuarantor &&
			this.quoteAppData.applicationsDataAnswered.businessInfo.isApplicantGuarantor
		) {
			return true;
		}
		return false;
	}

	hasAgreedTerms() {
		return !!this.sessionLogs?.some(sl => sl?.agreedTerms);
	}

	update(application) {
		try {
			util.deepUpdate(this, application);
		} catch (error) {
			console.error('Error updating:', error);
		}
	}
}
